import { withMultiButtonSelectHOC } from "shared/HOC";

const DEFAULT_TAGS = [
  { value: 'Artsy', label: 'Artsy' },
  { value: 'Casual', label: 'Casual' },
  { value: 'Comfortable', label: 'Comfortable' },
  { value: 'Edgy', label: 'Edgy' },
  { value: 'Feminine', label: 'Feminine' },
  { value: 'Glam', label: 'Glam' },
  { value: 'MOM', label: 'MOM' },
  { value: 'Minimal', label: 'Minimal' },
  { value: 'Non-Binary', label: 'Non-Binary' },
  { value: 'Preppy', label: 'Preppy' },
  { value: 'Sophisticated', label: 'Sophisticated' },
  { value: 'Trendy', label: 'Trendy' }
];

const TagsSelectButtons = withMultiButtonSelectHOC(DEFAULT_TAGS);
export default TagsSelectButtons;
